import OptVerification from ".";

export const OptVerificationrRoutes = (data) => [
  {
    path: "/account-verification",
    title: "OTP",
    layout: "auth",
    routeType: "auth",
    component: OptVerification,
  },
];
